import React, {
  useEffect,
  useState,
  memo,

} from "react";
import { Box, Grid, Paper, TextField, Typography, Button } from "@material-ui/core";

import { getObject, getOrganizationId, toastError, toastSuccess } from "../../../utils";
import _, { cloneDeep } from "lodash";
import CalculatorContainer from "./VoyageCalculator/CalculatorContainer";
import { updateUser } from "../UserProfile/action";
import moment from "moment";

export const isUser30DaysOld = (user) => {
  return moment().diff(moment(user?.createdAt), "days") >= 30;
};
function Calculator(props) {
  const user = getObject("auth");
  const [reason, setReason] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (reason === "") {
      toastError("Please write a reason");
      return
    }
    const requestData = {
      reason: reason,
      createdAt: new Date().toISOString(),
    };

    updateUser({ request: requestData })
      .then((res) => {
        toastSuccess('Request submited successfully');
        setReason("");
      })
      .catch((err) => {
        console.error('Error updating user details:', err);
        toastError('Error updating user details');
      });
  };

  if (user?.isPaid || !isUser30DaysOld(user)) {
    return <CalculatorContainer {...props} />;
  }


  return (
    <div className="flex min-h-[calc(100vh-110px)] items-center justify-center bg-gray-50 p-4">
      <Paper elevation={0} className="w-full max-w-2xl overflow-hidden rounded-xl border border-gray-200 shadow-xl">

        {/* 1. Header & Feature Showcase */}
        <div className="bg-gradient-to-b from-white to-gray-50 px-8 py-8 text-center border-b border-gray-200">
          <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-sky-100 shadow-sm">
            <svg className="h-7 w-7 text-sky-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>

          <h2 className="text-2xl font-bold text-gray-900">
            Unlock Matrix Estimation
          </h2>
          <p className="mt-3 text-base text-gray-600 max-w-lg mx-auto">
            Access to the Voyage Calculator is restricted. Request permission to unlock advanced fleet analytics and financial tools.
          </p>

          {/* Feature Grid - Extracted from your code */}
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
            {/* Feature 1: Derived from <VesselSelection> & <OrdersList> */}
            <div className="flex items-start rounded-lg bg-white p-3 border border-gray-100 shadow-sm">
              <div className="shrink-0 text-sky-500 mt-0.5">
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
              </div>
              <div className="ml-3">
                <h4 className="text-sm font-semibold text-gray-900">Smart Cargo Matching</h4>
                <p className="text-xs text-gray-700">Auto-match cargoes with available vessels and compare fleets.</p>
              </div>
            </div>

            {/* Feature 2: Derived from <PieChart> & Expenses Data */}
            <div className="flex items-start rounded-lg bg-white p-3 border border-gray-100 shadow-sm">
              <div className="shrink-0 text-emerald-500 mt-0.5">
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" /></svg>
              </div>
              <div className="ml-3">
                <h4 className="text-sm font-semibold text-gray-900">P&L & Expense Analysis</h4>
                <p className="text-xs text-gray-700">Visual breakdown of voyage duration, port dues, and bunker costs.</p>
              </div>
            </div>

            {/* Feature 3: Derived from <ShowMap> & fetchPortDistance */}
            <div className="flex items-start rounded-lg bg-white p-3 border border-gray-100 shadow-sm">
              <div className="shrink-0 text-sky-500 mt-0.5">
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 7m0 13V7" /></svg>
              </div>
              <div className="ml-3">
                <h4 className="text-sm font-semibold text-gray-900">Route & Map Visualization</h4>
                <p className="text-xs text-gray-700">Interactive map view with port distance and canal transit logic.</p>
              </div>
            </div>

            {/* Feature 4: Derived from <PortOperations> & <MarginAndAllowances> */}
            <div className="flex items-start rounded-lg bg-white p-3 border border-gray-100 shadow-sm">
              <div className="shrink-0 text-amber-500 mt-0.5">
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              </div>
              <div className="ml-3">
                <h4 className="text-sm font-semibold text-gray-900">Margins & Allowances</h4>
                <p className="text-xs text-gray-700">Calculate supply costs, port operations, and profit margins.</p>
              </div>
            </div>
          </div>
        </div>

        {/* 2. Form Section */}
        <div className="p-8 bg-white">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <TextField
                label="Reason for Access"
                variant="outlined"
                fullWidth
                multiline
                rows={3}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="e.g., I need to calculate bunker costs for the Iron Ore shipment."
                InputLabelProps={{ shrink: true, className: "font-medium text-gray-800" }}
              />
            </div>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              disableElevation
              className="py-3.5 text-base font-semibold text-white bg-sky-600 hover:bg-sky-700 rounded-lg capitalize transition-all"
              style={{ textTransform: 'none' }}
            >
              Submit Request
            </Button>

            <p className="text-center text-xs text-gray-400">
              Requests are typically reviewed by admins within 24 hours.
            </p>
          </form>
        </div>

      </Paper>
    </div>
  );
}

export default memo(Calculator);
